var RedactionShapeModel = require('../redaction'),
    FullPageRedactionShapeUiModel = require('./shapeUIModel'),
    ShapeUtils = require('../../../shapeUtils'),
    _ = require('underscore');



module.exports = RedactionShapeModel.extend({

    APPLY_LAST_REASON_CODES_FROM_LOCAL_STORAGE: 0,
    APPLY_LAST_FILL_FROM_LOCAL_STORAGE: 0,

    STORE_SELECTED_FILL_TO_LOCAL_STORAGE: 0,
    STORE_LAST_REASON_CODES_TO_LOCAL_STORAGE: 0,

    ShapeUIModel: FullPageRedactionShapeUiModel,

    // Make clear these can't be converted to float
    constructor: function(attrs) {

        RedactionShapeModel.prototype.constructor.apply( this, arguments );

        this.isConvertingToFloatingCodes = false;

    },

    /**
     * Fill is essentially not applicable.
     * White is chosen because it's more printer friendly and it
     * will work out of the box with 'apply all redactons mode'.
     * Override also serves to ignore setting the fill from local storage
     * -- which aren't applicable to the note type
     */
    defaults: function() {

        return _.extend( {}, RedactionShapeModel.prototype.defaults.apply( this, arguments ), {
            fill: 'WHITE'
        });

    },

    /**
     * Don't derive the points from the shape el, which will
     * results in rounding issues and potentially negative values.
     * Plus it's simpler just to get the values directly from the converted page dimensions.
     */
    _getPointsFromEl: function() {

        // First emphasize can't be created on cold/text pages
        if ( this.pageModel.isCold() )
            return null;

        return ShapeUtils.getPointsToSaveFromPageDimensions( this.pageModel );

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/coordinate/redaction/fullPageRedaction/shapeModel.js
 ** module id = 318
 ** module chunks = 0
 **/